define('base/vent',['require','exports','module','backbone','base/class','lodash'],function(require, exports, module) {
  "use strict";

  var Backbone = require("backbone"),
      Class = require("base/class"),
      _ = require("lodash");

  var triggerMethod = function(event) {
    var args = [].slice.call(arguments, 1),
        methodName = event.split(":").reduce(function(acc, el) {
          return acc + el[0].toUpperCase() + el.slice(1);
        }, "on");
    this.trigger.apply(this, [event].concat(args));
    if (typeof(this[methodName]) === "function") {
      this[methodName].apply(this, args);
    }
  };


  _.extend(Backbone.Events, {triggerMethod: triggerMethod});
  _.extend(Backbone.View.prototype, {triggerMethod: triggerMethod});
  _.extend(Backbone.Model.prototype, {triggerMethod: triggerMethod});
  _.extend(Backbone.Collection.prototype, {triggerMethod: triggerMethod});

  /* Vent */

  var ventMixin = {
    forward: function(target) {
      this.listenTo(target, "all", _.bind(function() {
        return this.trigger.apply(this, arguments);
      }, this));
    },
    forwardAll: function(targets) {
      _.each(targets, this.forward, this);
    }
  };

  _.each([ Backbone.Events, Backbone.View.prototype, Backbone.Model.prototype,
           Backbone.Collection.prototype ],
         _.partialRight(_.extend, ventMixin));

  var Vent = Class.extend({});
  _.extend(Vent.prototype, Backbone.Events);

  module.exports = Vent;
});

